<template>
	<div>
			<b-col cols="12">
					<h2>{{ $t('patient-panel.foods') }}</h2>
			</b-col>
			<b-row class="neu-cards-ctn landing-cnt  mt-5" cols="1" cols-xl="4">
				<PatientPanelServiceBlock id="food-healthy" visible :title="$t('patient-panel.caring-foods')" :action="() => { $router.push('/patient/foods') }" img="/static-appopensalud/img/icons/morillas-svg-icons/primary/fruit.svg" />
				<!-- <PatientPanelServiceBlock id="healthy-blog" visible :title="$t('patient-panel.healthy-blog')" soonLabel  :action="() => { appHelpers.goToBlog() }"  img="/static-appopensalud/img/icons/morillas-svg-icons/primary/blog.svg" /> -->
				<PatientPanelServiceBlock id="wellwo" :visible="wellwoVisible" :action="() => { goToWellwo('nut') }" :title="$t('patient-panel.diets-recipes')" img="/static-appopensalud/img/icons/morillas-svg-icons/primary/healthy-diets-and-food-recipes.svg" />
			</b-row>
	</div>
</template>

<script>
import PatientPanelServiceBlock from '@/components/PatientPanelServiceBlock'
import appHelpers from '@/helpers/app.helpers'
import { WELLWO_SERVICE } from '@/constants/patientServices'
import companyServicesMixin from '@/mixins/companyServices.mixin'

export default {
	components: {
			PatientPanelServiceBlock
	},
	mixins: [companyServicesMixin],
	data () {
		return {
				appHelpers
		}
	},
	computed: {
		wellwoVisible () {
			return this.$store.getters['session/userHasActiveCompanyService'](WELLWO_SERVICE)
		}
	}
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/HealthyFoodPanelMenu.vue